import { Fragment } from "react";
import "./P2EgameDevelopment.css";
import { p2egameDevelopment } from "../../staticdata";
import playtoearnbanner from "../../assets/images/services/metaverse/playtoearnbanner.jpg";

const P2EgameDevelopment = () => {
  return (
    <Fragment>
      <section className="p2egamedev-style">
        <div className="p2egamedev-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="p2egamedev-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Play to Earn Game Development Services
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  A leading P2E game development company, we combine advanced
                  gaming mechanics, blockchain integration, and NFT technology
                  to deliver tailored solutions that drive player engagement and
                  foster business growth. Our team of experienced game
                  developers and blockchain engineers works closely with clients
                  to understand their unique challenges and create custom
                  solutions that unlock new revenue streams, enhance gaming
                  experiences, and ensure the longevity of their games.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={playtoearnbanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="p2egamedev-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our{" "}
                <span className="title-gradient">
                  Play to Earn Game Development{" "}
                </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {p2egameDevelopment.map((services, index) => (
                <div
                  className="col-lg-4 col-md-6"
                  key={services.id}
                  data-aos="zoom-in"
                >
                  <div className="p2egamedev-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default P2EgameDevelopment;
